<div class="payment-slider-box">
  <div class="payment-slider">
    <span class="slider-per-value">0%</span>
    <nouislider #slider [config]="sliderConfig" (slide)="onSlide($event)" (end)="onEndSlider($event)" [disabled]="isDisabled" [(ngModel)]="sliderValue" class="payment-nouislider"></nouislider>
    <span class="slider-per-value">100%</span>
  </div>

  <div class="payment-info">
    <span class="payment-info-text">Adjust Deposit Payment:</span>
    <strong id="depositeAmount">${{ formatCurrency(depositAmount) }}({{ sliderValue| number:'1.2-2' }}%)</strong>

    @if (!isDisabled) {
      <button role="button" class="price-edit-icon" [ngbPopover]="priceContent" [autoClose]="'outside'" triggers="manual" [disabled]="isDisabled" #updateSliderValue="ngbPopover" [popoverTitle]="priceTitle" (click)="resetUpdateSlider(updateSliderValue)">
        <img src="/assets/admin/images/pen-edit-small-icon.svg" height="16" width="16" alt="Edit" ngbTooltip="Edit"/>
      </button>

      <ng-template #priceTitle>
        <img src="/assets/admin/images/pen-edit-small-icon.svg" height="16" width="16" alt="Edit" />
        Edit slider value
        <span class="close-btn" (click)="closeUpdateSlider(updateSliderValue)">
            <img src="/assets/admin/images/close-icon.svg" height="16" width="16" alt="close-icon" title="Close" />
          </span>
      </ng-template>

      <ng-template #priceContent>
        <form [formGroup]="sliderForm" *ngIf="sliderForm">
          <!-- Percentage input group -->
          <div class="form-group">
            <label>Percentage:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">%</span>
              </div>
              <input
                class="form-control"
                type="text"
                formControlName="percentage"
                (input)="onInputChange('percentage')"
                (blur)="onFocusOutEvent($event, 'percentage')"
                (keypress)="checkDecimalDot($event)"
                [maxlength]="sliderPercentageMaxChars"
                pattern="^\d+(\.\d{1,4})?$"
                appDecimalInput
              />
            </div>
            <div class="text-danger mt-1"
                 *ngIf="sf.percentage.invalid && (sf.percentage.touched || submitted)">
              <small *ngIf="sf.percentage.errors?.['required']">Enter percentage.</small>
              <small *ngIf="sf.percentage.errors?.['invalidPercentage']">Percentage must be between 0.01 and 100.</small>
            </div>
          </div>

          <!-- Dollar input group -->
          <div class="form-group">
            <label>Value:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">$</span>
              </div>
              <input
                class="form-control"
                type="text"
                formControlName="value"
                (input)="onInputChange('value')"
                (blur)="onFocusOutEvent($event, 'value')"
                (keypress)="checkDecimalDot($event)"
                pattern="^\d+(\.\d{1,2})?$"
                appCurrencyInput
                [decimalPlaces]="2"
              />
            </div>
            <div class="text-danger mt-1"
                 *ngIf="sf.value.invalid && (sf.value.touched || submitted)">
              <small *ngIf="sf.value.errors?.['required']">Enter value.</small>
              <small *ngIf="sf.value.errors?.['invalidValue']">Value must be between $0.01 and ${{ finalAmount | number:'1.2-2' }}</small>
            </div>
          </div>

          <!-- Update button -->
          <div class="edit-price-action">
            <button type="button" class="btn" (click)="onUpdateClick(updateSliderValue)">Update</button>
          </div>
        </form>
      </ng-template>
    }
  </div>
</div>
